import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import MissionPage from '../../../mission/components/MissionPage';
import LogoutPage from '../../../authentication/components/LogoutPage';
import PatrolPage from '../../../patrol/components/PatrolPage';
import CallbackPage from '../../../authentication/components/CallbackPage';
import ClientPage from '../../../client/components/pages/ClientPage';
import ErrorPage from '../../../error/components/ErrorPage';
import NotFoundPage from '../../../error/components/NotFoundPage';
import HelpPage from '../../../help/HelpPage';

const mainPagePath = '/missions';

const routes = [
  { path: '/missions', component: MissionPage },
  { path: '/reports', component: PatrolPage },
  { path: '/clients', component: ClientPage },
  { path: '/callback', component: CallbackPage },
  { path: '/logout', component: LogoutPage },
  { path: '/help', component: HelpPage },
  { path: '/errors/:errorType(api)', component: ErrorPage },
  { path: '/404', component: NotFoundPage },
];

const Router = () => (
  <Switch>
    <Redirect exact from="/" to={mainPagePath} />

    {routes.map(({ path, component }) => (
      <Route key={path} strict path={path} component={component} />
    ))}
  </Switch>
);

export default Router;
